module.exports = __webpack_public_path__ + "static/img/labourservices-7.9427b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservices-7.png
// module id = rv2m
// module chunks = 1